<template>
  <div class="content">
    <div class="page" v-show="index==0">
        <div class="title">{{type==1?'商户员工':type==2?'外保人员':type==3?'三方公司员工':''}}信息登记</div>
        <van-form :show-error-message="false" :scroll-to-error="true" @submit="onSubmit">
          <div class="tit">请选择入职门店</div>
            <van-field v-model="shopName" :name="shopName" placeholder="请选择入职门店" readonly :rules="[{ required: true, message: '请选择入职门店' }]" @click.prevent="getshowshop()">
              <template #button>
                  <div class="van-field__left-icon" @click.prevent="getshowshop()">
                      <i class="van-badge__wrapper van-icon van-icon-search"></i>
                  </div>
              </template>
            </van-field>
            <div class="tit">请输入身份证号/护照号</div>
            <van-field v-model="idCardNo" name="idCardNo" placeholder="请输入身份证号/护照号" :rules="[{ required: true, message: '请输入身份证号/护照号' }]"/>
            <div style="margin: 0.6rem 0;">
                <van-button round block type="primary" native-type="submit" :loading="loading">
                    开始填写
                </van-button>
            </div>
        </van-form>
    </div>
    <div class="page" v-show="index==1">
        <div class="title">员工信息登记</div>
        <van-form :show-error-message="false" :scroll-to-error="true" @submit="goSubmit">
          <div class="tmt">基本信息</div>
          <div class="txt"><i>*</i>1.姓名</div>
          <van-field v-model="form.realName" name="realName" placeholder="请输入姓名" :rules="[{ required: true, message: '请输入姓名' }]" :readonly="btndis"/>
          <div class="txt"><i>*</i>2.身份证类型</div>
          <van-field name="certificate" class="noborder">
            <template #input>
              <van-radio-group v-model="form.idCardType" :disabled="btndis">
                  <van-radio name="1">身份证</van-radio>
                  <van-radio name="2">护照</van-radio>
              </van-radio-group>
            </template>
          </van-field>
          <div class="txt"><i>*</i>3.{{form.idCardType==1?'身份证号':'护照号'}}</div>
          <van-field v-if="form.idCardType==1" v-model="form.idCardNo" @input="getidcard" name="guideIdCard" placeholder="请输入身份证号" :rules="telRules3" :readonly="btndis"/>
          <van-field v-if="form.idCardType==2" v-model="form.idCardNo" name="guidePassportNo" placeholder="请输入护照号" :rules="[{ required: true, message: '请输入护照号' }]" :readonly="btndis"/>
          <div class="txt" v-if="form.idCardType==2"><i>*</i>护照签发日期</div>
          <van-field v-if="form.idCardType==2" readonly clickable name="issueDate" :value="form.issueDate" placeholder="请选择护照签发日期" :rules="[{ required: true, message: '请选择护照签发日期' }]" @click="getshowPicker47" />
              <van-popup v-model="showPicker47" position="bottom">
              <van-datetime-picker
                  v-model="currentDate47"
                  type="date"
                  :min-date="minDate"
                  :max-date="maxDate1"
                  @confirm="onConfirmtwo47"
                  @cancel="showPicker47 = false"/>
              </van-popup>
          <div class="txt" v-if="form.idCardType==2"><i>*</i>护照有效期至</div>
          <van-field v-if="form.idCardType==2" readonly clickable name="expireDate" :value="form.expireDate" placeholder="请选择护照有效期至" :rules="[{ required: true, message: '请选择护照有效期至' }]" @click="getshowPicker48" />
              <van-popup v-model="showPicker48" position="bottom">
              <van-datetime-picker
                  v-model="currentDate48"
                  type="date"
                  :min-date="minDate"
                  :max-date="maxDate1"
                  @confirm="onConfirmtwo48"
                  @cancel="showPicker48 = false"/>
              </van-popup>
          <div class="txt"><i>*</i>4.性别</div>
          <van-field name="uploader" class="noborder">
            <template #input>
              <van-radio-group v-model="form.sex" :disabled="btndis">
                  <van-radio name="1">男</van-radio>
                  <van-radio name="2">女</van-radio>
              </van-radio-group>
            </template>
          </van-field>
          <div class="txt"><i>*</i>5.民族</div>
          <van-field v-model="form.nation" name="nation" placeholder="请输入民族" :rules="[{ required: true, message: '请输入民族' }]" :readonly="btndis"/>
          <div class="txt"><i>*</i>6.生日</div>
          <van-field readonly clickable name="date" :value="form.birthday" placeholder="请选择生日" :rules="[{ required: true, message: '请选择生日' }]"
              @click="getshowPicker" />
              <van-popup v-model="showPicker1" position="bottom">
              <van-datetime-picker
                  v-model="currentDate"
                  type="date"
                  :min-date="minDate"
                  :max-date="maxDate"
                  @confirm="onConfirmtwo"
                  @cancel="showPicker1 = false"/>
              </van-popup>
          <div class="txt"><i>*</i>7.手机号</div>
          <van-field v-model="form.mobile" name="mobile" placeholder="请输入手机号" :rules="telRules2" :readonly="btndis"/>
          <div class="txt"><i>*</i>8.学历</div>
          <van-cell-group inset>
              <van-field
                v-model="form.educationCodeName"
                is-link
                readonly
                name="picker"
                placeholder="点击选择学历"
                :rules="[{ required: true, message: '请选择学历' }]"
                @click="getshowPicker2()"/>
              <van-popup v-model="showPicker2" position="bottom">
                <van-picker
                  :show-toolbar="true"
                  :columns="columns2"
                  @confirm="onConfirm2"
                  @cancel="showPicker2 = false"
                />
              </van-popup>
          </van-cell-group>
          <div class="txt"><i>*</i>9.籍贯</div>
          <van-field v-model="form.nativePlace" name="nativePlace" placeholder="请输入籍贯" :rules="[{ required: true, message: '请输入籍贯' }]" :readonly="btndis"/>
          <div class="txt"><i>*</i>10.现住址</div>
          <van-field v-model="form.currentAddr" name="currentAddr" placeholder="请输入现住址" :rules="[{ required: true, message: '请输入现住址'}]" :readonly="btndis"/>
          <div class="txt"><i>*</i>11.上传一寸证件照</div>
          <van-field name="idPhotoImg" class="noborder" :rules="[{ required: form.idPhotoImg=='' || form.idPhotoImg==null?true:false, message: '请上传证件照上传' }]">
            <template #input>
              <van-uploader v-if="form.idPhotoImg=='' || form.idPhotoImg==null" :before-read="beforeRead" :after-read="(file)=>afterRead(file, 1)" multiple :max-count="1" show-upload upload-text="证件照" :readonly="btndis">
              </van-uploader>
              <div class="widbox" v-else>
                <van-image width="100%" height="auto" fit="cover" position="bottom" @click="geshow(form.idPhotoImg)" :src="form.idPhotoImg"/>
                <i @click="delimg(1)" v-if="!btndis">x</i>
              </div>
            </template>
          </van-field>
          <div class="tipss">支持上传jpg、jpeg、png格式</div>
          <div style="margin: 0.6rem 0;">
            <van-button round block type="primary" native-type="submit" :loading="loading">
              下一步
            </van-button>
          </div>
        </van-form>
    </div>
    <div class="page" v-show="index==2">
        <div class="title">员工信息登记</div>
        <van-form :show-error-message="false" :scroll-to-error="true" @submit="goSubmit">
          <div v-for="(item,nindex) in form.ledgerShopList" :key="nindex">
            <div class="tmt">
              <div><i>*</i>入职门店</div>
              <div v-if="!btndis">
                <img @click="addshop()" src="@/assets/add.png"/>
                <img v-if="nindex>0" @click="delshop(nindex)" src="@/assets/del.png"/>
              </div>
            </div>
            <van-field v-model="item.shopName" :name="'ledgerShopList.' + nindex + '.shopName'" placeholder="请选择入职门店" readonly :rules="[{ required: true, message: '请选择入职门店' }]" @click.prevent="getshowshop(nindex)">
                <template #button>
                    <div class="van-field__left-icon" @click.prevent="getshowshop()">
                        <i class="van-badge__wrapper van-icon van-icon-search"></i>
                    </div>
                </template>
            </van-field>
            
            <div v-for="(otem,mindex) in item.ledgerShopBrandList" :key="mindex">
              <div class="tmt">就职单位
                <div v-if="!btndis">
                <img @click="addbrand(nindex)" src="@/assets/add.png"/>
                <img v-if="mindex>0" @click="delbrand(nindex,mindex)" src="@/assets/del.png"/>
              </div>
              </div>
            <div class="txt">1.公司名称</div>
            <van-field v-model="otem.supply" placeholder="请输入公司名称" :readonly="btndis">
                <template #button>
                  <div class="van-field__left-icon" @click.prevent="getshowsupply(nindex,mindex)">
                      <i class="van-badge__wrapper van-icon van-icon-search"></i>
                  </div>
                </template>
            </van-field>

            <div class="txt">2.就职品牌</div>
            <van-field v-model="otem.brandName"  placeholder="请输入就职品牌" :readonly="btndis">
                <template #button>
                  <div class="van-field__left-icon" @click.prevent="getshowbrand(nindex,mindex)">
                      <i class="van-badge__wrapper van-icon van-icon-search"></i>
                  </div>
                </template>
            </van-field>
            <div class="txt"><i>*</i>3.职位</div>
            <van-field v-model="otem.position" :name="'ledgerShopList.' + nindex + '.position'" placeholder="请输入职位" :rules="[{ required: true, message: '请输入职位' }]" :readonly="btndis"/>
            </div>

          </div>
          <div class="formfoot"></div>
          <div class="fixdbottom" style="margin: 0.6rem 0;">
            <van-button round block type="primary" native-type="button" @click.prevent="cutindex()">上一步</van-button>
            <van-button round block type="primary" native-type="submit" :loading="loading">下一步</van-button>
          </div>
        </van-form>
      </div>
    <div class="page" v-show="index==3">
        <div class="title">员工信息登记</div>
        <van-form :show-error-message="false" :scroll-to-error="true" @submit="goSubmit">
          <div class="tmt">
              <span>紧急联系人</span>
            </div>
            <div class="txt"><i>*</i>1.关系</div>
            <van-cell-group inset>
              <van-field
                v-model="form.memberRelation"
                is-link
                readonly
                name="picker"
                placeholder="点击紧急联系人关系"
                :rules="[{ required: true, message: '请填写紧急联系人关系' }]"
                @click="getshowgent()"/>
              <van-popup v-model="showgent" position="bottom">
                <van-picker
                  :show-toolbar="true"
                  :columns="gentcolumns"
                  @confirm="onConfirmgent"
                  @cancel="showgent = false"
                />
              </van-popup>
          </van-cell-group>
            <div class="txt"><i>*</i>2.姓名</div>
            <van-field v-model="form.memberName" name="memberName" placeholder="请填写紧急联系人姓名" :rules="[{ required: true, message: '请填写紧急联系人姓名' }]" :readonly="btndis"/>
            <div class="txt"><i>*</i>3.联系方式</div>
            <van-field v-model="form.memberMobile" name="memberMobile" placeholder="请填写紧急联系方式" :rules="telRules2" :readonly="btndis"/>
          <div class="formfoot"></div>
          <div class="fixdbottom" style="margin: 0.6rem 0;">
            <van-button round block type="primary"  @click.prevent="cutindex()">上一步</van-button>
            <van-button round block type="primary" native-type="submit" :loading="loading">下一步</van-button>
          </div>
        </van-form>
    </div>
    <div class="page" v-show="index==4">
      <div class="title">员工信息登记</div>
      <van-form :scroll-to-error="true" @submit="goSubmit">
        <div class="tmt">证件信息</div>
        <div class="txt"><i>*</i>1.身份证人脸照</div>
        <van-field name="idCardFaceImg" class="noborder zm" placeholder="身份证人脸照" :rules="[{ required: form.idCardFaceImg=='' || form.idCardFaceImg==null?true:false, message: '请上传身份证人脸照照片' }]" v-if="form.idCardFaceImg=='' || form.idCardFaceImg==null">
          <template #input>
            <van-uploader :before-read="beforeRead" :after-read="(file)=>afterRead(file, 2)" multiple :max-count="1" show-upload upload-text="身份证人脸照" :readonly="btndis"></van-uploader>
          </template>
        </van-field>
        <van-field name="idCardFaceImg" class="noborder zm" placeholder="身份证人脸照" :rules="[{ required: form.idCardFaceImg=='' || form.idCardFaceImg==null?true:false, message: '请上传身份证人脸照照片' }]" v-else>
          <template #input>
            <div class="widbox">
              <van-image width="100%" height="auto" fit="cover" position="bottom" @click="geshow(form.idCardFaceImg)" :src="form.idCardFaceImg"/>
              <i @click="delimg(2)" v-if="!btndis">x</i>
            </div>
          </template>
        </van-field>
        <div class="tipss">支持上传jpg、jpeg、png格式</div>
        <div class="txt"><i>*</i>2.身份证国徽照</div>
        <van-field name="idCardEmblemImg" class="noborder fm" :rules="[{ required: form.idCardEmblemImg=='' || form.idCardEmblemImg==null?true:false, message: '请上传身份证国徽照照片' }]" v-if="form.idCardEmblemImg=='' ||  form.idCardEmblemImg==null">
          <template #input>
            <van-uploader :before-read="beforeRead" :after-read="(file)=>afterRead(file, 3)"  multiple :max-count="1" show-upload upload-text="身份证国徽照"/>
          </template>
        </van-field>
        <van-field name="idCardEmblemImg" class="noborder fm" :rules="[{ required: form.idCardEmblemImg=='' || form.idCardEmblemImg==null?true:false, message: '请上传身份证国徽照照片' }]" v-else>
          <template #input>
            <div class="widbox">
              <van-image width="100%" height="auto" fit="cover" position="bottom" @click="geshow(form.idCardEmblemImg)" :src="form.idCardEmblemImg" :readonly="btndis"/>
              <i @click="delimg(3)" v-if="!btndis">x</i>
            </div>
          </template>
        </van-field>
        <div class="tipss" :class="form.age<18?'':'formfoot'">支持上传jpg、jpeg、png格式</div>
        <div v-if="form.age<18">
          <div class="tmt">附件上传</div>
          <div class="txt"><i>*</i>3.电子合同</div>
          <van-field name="electronicContract" class="noborder notop" placeholder="电子合同" :rules="[{ required:!form.electronicContract || form.electronicContract==''?true:false, message: '请上传电子合同' }]" v-if="!form.electronicContract || form.electronicContract==''">
            <template #input>
              <van-uploader class="noheight" v-model="form.idCardEmblemImg" :max-count="1" accept="image/*,.pdf,.docx"  :before-read="beforeRead1" :readonly="btndis"> 
                  <van-button icon="plus" type="primary" size="small">上传文件</van-button>
              </van-uploader>
            </template>
          </van-field>
          <div class="row-between" v-if="form.electronicContract && form.electronicContract!=''">
            <div class="name" @click="show=true">电子合同</div>
            <img style="width:0.5rem;height:0.5rem" @click="deleteImg()" src="@/assets/del.png" v-if="!btndis"/>
          </div>
          <div class="tipss formfoot">支持上传jpg、jpeg、png、pdf、docx格式</div>
        </div>
        <div class="fixdbottom" style="margin: 0.6rem 0;" v-if="!btndis">
          <van-button round block type="primary" @click.prevent="cutindex()">上一步</van-button>
          <van-button round block type="primary" native-type="submit" :loading="loading">下一步</van-button>
        </div>
        <div class="fixdbottom fixdbottom2" style="margin: 0.6rem 0;" v-else>
          <van-button round block type="primary" @click.prevent="cutindex()">上一步</van-button>
        </div>
        
      </van-form>
    </div>
    <div class="page" v-if="index==5">
      <div class="boximg flexcenter">
        <img src="@/assets/suc.png"/>
        <div class="text">
          <div class="btit flexcenter">提交成功</div>
          <p>感谢您的提交</p>
        </div>
      </div>
    </div>
    <div v-if="showsupply">
      <van-popup
        v-model="showsupply"
        position="bottom"
        :style="{ height: '60%' }">
        <van-search v-model="supply" @input="set" placeholder="请输入搜索关键词" />
        <van-list finished-text="没有更多了">
          <van-cell v-for="(item,index) in filterList" :key="index" @click="gosupply(index)">
            <div v-html="item.name"></div>
          </van-cell>
        </van-list>
      </van-popup>
    </div>
    <div v-if="showbrand">
      <van-popup
        v-model="showbrand"
        position="bottom"
        :style="{ height: '60%' }">
        <van-search v-model="brand" @input="setbrand" placeholder="请输入搜索关键词" />
        <van-list finished-text="没有更多了">
          <van-cell v-for="(item,index) in brandList1" :key="index" @click="gobrand(index)">
            <div v-html="item.name"></div>
          </van-cell>
        </van-list>
      </van-popup>
    </div>
    <div v-if="showshop">
      <van-popup
        v-model="showshop"
        position="bottom"
        :style="{ height: '60%' }">
        <van-search v-model="brand" @input="setshop" placeholder="请输入搜索关键词" />
        <van-list finished-text="没有更多了">
          <van-cell v-for="(item,index) in shoplist" :key="index" @click="goshop(index)">
            <div v-html="item.name"></div>
          </van-cell>
        </van-list>
      </van-popup>
    </div>
    <div class="showbj" v-if="showloading">
      <van-loading type="spinner" color="white" size="60"/>
    </div>
    <van-popup v-model="show" position="center" :closeable="true" :style="{width:'80%',height: '60%' }">
        <iframe :src="'https://view.xdocin.com/view?src='+form.electronicContract" style="width: 100%;height: 100%" frameborder="0" />
    </van-popup>
  </div>
</template>

<script>
import { ImagePreview } from 'vant'
import html2canvas from 'html2canvas'
import moment from 'moment'
import * as imageConversion from 'image-conversion';
export default {
  name: 'addledger',
  data () {
    return {
        form:{
          idCardFaceImg:'',
          idCardEmblemImg:'',
          electronicContract:'',
        },
        index:0,
        idCardNo:'',
        shopName:'',
        shopSid:'',
        loading:false,
        supply:'',
        shop:'',
        show:false,
        showshop:false,
        showsupply:false,
        showbrand:false,
        brand:'',
        showgent:false,
        showloading:false,
        showPicker1:false,
        showPicker2:false,
        showPicker47:false,
        showPicker48:false,
        currentDate:'',
        currentDate47:'',
        currentDate48:'',
        currentDate:new Date(2022, 10, 1),
        minDate: new Date(1942, 0, 1),
        maxDate: new Date(2025, 10, 1),
        maxDate1: new Date(2050, 10, 1),
        list:[],
        filterList:[],
        filterList2:[],
        brandList:[],
        brandList1:[],
        brandList2:[],
        shoplist:[],
        shoplist2:[],
        gentcolumns:['父子/女', '母子/女','兄弟/姐妹','夫妻','其他'],
        columns2:['1-小学', '2-初中', '3-中专', '4-高中', '5-大专', '6-大学', '7-研究生'],
        telRules2:[{
            required: true,
            message: '请输入手机号',
            trigger: 'onBlur'
        }, {
            validator: value => {
                return /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/.test(value)
            },
            message: '手机号格式不正确',
            trigger: 'onBlur'
        }],
        telRules3:[{
            required: true,
            message: '请输入身份证号',
            trigger: 'onBlur'
        }, {
            validator: value => {
                return /^\d{6}(((19|20)\d{2}(0[1-9]|1[0-2])(0[1-9]|[1-2][0-9]|3[0-1])\d{3}([0-9]|x|X))|(\d{2}(0[1-9]|1[0-2])(0[1-9]|[1-2][0-9]|3[0-1])\d{3}))$/.test(value)
            },
            message: '身份证号格式不正确',
            trigger: 'onBlur'
        }],
        nindex:'',
        mindex:'',
        btndis:false,
    }
  },
  created(){
    this.type=this.$route.params.type
    document.title = this.type==1?'商户员工信息登记':this.type==2?'外保人员信息登记':this.type==3?'三方公司员工信息登记':'' 
    this.getshop()
  },
  methods:{
    cutindex(){
      let that=this;
      that.index=that.index-1
    },
    onSubmit(values){
        let that=this
        that.loading=true
        that.$axios.get(process.env.API_HOST+"sysmanager/applets/ledger/idCard?idCardNo="+that.idCardNo).then((res) => {
            that.loading=false
            if(res.data.state==200){
                that.form=res.data.data
                that.form.idPhotoImg=res.data.data.idPhotoImg && res.data.data.idPhotoImg!='' && res.data.data.idPhotoImg!=null?res.data.data.idPhotoImg:''
                that.form.idCardFaceImg=res.data.data.idCardFaceImg && res.data.data.idCardFaceImg!='' && res.data.data.idCardFaceImg!=null?res.data.data.idCardFaceImg:''
                that.form.idCardEmblemImg=res.data.data.idCardEmblemImg && res.data.data.idCardEmblemImg!='' && res.data.data.idCardEmblemImg!=null?res.data.data.idCardEmblemImg:''
                that.form.electronicContract=res.data.data.electronicContract && res.data.data.electronicContract!='' && res.data.data.electronicContract!=null?res.data.data.electronicContract:''
                that.form.idCardNo=that.form.idCardNo=='' || that.form.idCardNo==null?that.idCardNo:that.form.idCardNo
                that.form.birthday=that.form.birthday && that.form.birthday!='' && that.form.birthday!=null?moment(that.form.birthday).format('YYYY-MM-DD'):''
                that.form.idCardType=that.form.idCardType && that.form.idCardType!='' && that.form.idCardType!=null?that.form.idCardType.toString():'1'
                that.form.sex=that.form.sex && that.form.sex!='' && that.form.sex!=null?that.form.sex.toString():'1'
                that.form.educationCodeName=that.form.educationCode && that.form.educationCode!='' && that.form.educationCode!=null?that.columns2[Number(that.form.educationCode)-1]:''
                that.index++
                that.btndis=that.form.reviewedUser && that.form.reviewedUser!='' && that.form.reviewedUser!=null?true:false
            }else{
                this.$toast(res.data.message);
            }
        }).catch((error) =>{
            that.loading=false
        });
    },
    deleteImg() {
      let that=this;
      that.form.electronicContract=''
      that.$forceUpdate();
    },
    downfile(){
      window.open(this.form.electronicContract)
    },
    beforeRead1(file){
      let that=this;
      let name=file.name.split('.')
      that.showloading=true
      if (name[name.length-1] != 'jpg' && name[name.length-1] != 'jpeg' && name[name.length-1] != 'png' && name[name.length-1] != 'pdf' && name[name.length-1] != 'docx') {
          that.$toast('文件格式不正确');
          that.showloading=false
          return false;
      }
      let form = new FormData()
      form.append('annexUrl', file)
      form.append('operator', that.form.mobile)
      that.$axios.post(process.env.API_HOST+"sysmanager/vue/guide/image",form).then((res) => {
        if(res.data.state==200){
          that.form.electronicContract=res.data.data.accessPath
          that.$forceUpdate();
        }else{
          that.form.electronicContract=''
          that.$toast(res.data.desc);
        }
        that.showloading=false
      }).catch((error) =>{
        that.showloading=false
      });
    },
    afterRead1(file){
      console.log("这里这里")
      let form = new FormData()
       if(file.file.lastModified && file.file.lastModified!=''){
        form.append('annexUrl', file.file)
        form.append('operator', that.form.mobile)
      }
      that.$axios.post(process.env.API_HOST+"sysmanager/vue/guide/image",form).then((res) => {
        if(res.data.state==200){
          that.form.electronicContract=res.data.data.accessPath
        }else{
          that.form.electronicContract=''
          that.$toast(res.data.desc);
        }
      }).catch((error) =>{
        that.showloading=false
      });
    },
    removeProperty (obj) {
        Object.keys(obj).forEach(item => {
            if (obj[item] === '' || obj[item] === [] || obj[item] === {} || obj[item] === undefined || obj[item] === null || obj[item] === 'null') delete obj[item]
        })
            return obj
    },
    goSubmit(values){
      let that=this
      if(that.btndis){
        that.index++
        return
      }
      that.loading=true
      if(that.form.sid && that.form.sid!='' && that.form.sid!=null){
        that.$axios.put(process.env.API_HOST+"sysmanager/vue/ledger",that.removeProperty(that.form)).then((res) => {
            that.loading=false
            if(res.data.state==200){
                that.index++
                that.form.age=that.form.birthday!='' && that.form.birthday!=null?that.getages1(that.form.birthday):that.form.idCardType==1?that.getages(that.form.idCard):''
                that.form.idCardFaceImg=res.data.data.idCardFaceImg && res.data.data.idCardFaceImg!='' && res.data.data.idCardFaceImg!=null?res.data.data.idCardFaceImg:''
                that.form.idCardEmblemImg=res.data.data.idCardEmblemImg && res.data.data.idCardEmblemImg!='' && res.data.data.idCardEmblemImg!=null?res.data.data.idCardEmblemImg:''
                that.form.electronicContract=res.data.data.electronicContract && res.data.data.electronicContract!='' && res.data.data.electronicContract!=null?res.data.data.electronicContract:''
            }else{
                that.$toast(res.data.message);
            }
        }).catch((error) =>{
            that.loading=false
        });
      }else{
        if(!that.form.ledgerShopList || that.form.ledgerShopList==null || that.form.ledgerShopList.length==0){
          that.form.ledgerShopList=[{
            index: 0,
            cancelCardTime: '',
            chestStatus: '',
            depositNo: '',
            depositStatus:'',
            guideNo:'',
            shopName:that.shopName,
            shopSid:that.shopSid,
            takeCardTime:'',
            ledgerShopBrandList:[{
              brandName:'',
              brandSid:'',
              jobType:that.$route.params.type,
              joinTime:'',
              position:'',
              quitTime:'',
              supplySid:'',
              index:0,
            }]
          }]
        }
        that.$axios.post(process.env.API_HOST+"sysmanager/vue/ledger",that.removeProperty(that.form)).then((res) => {
            that.loading=false
            if(res.data.state==200){
                that.form.sid=res.data.data.sid
                that.form.age=that.form.birthday!=''?that.getages1(that.form.birthday):that.form.idCardType==1?that.getages(that.form.idCard):''
                that.form.idCardFaceImg=res.data.data.idCardFaceImg && res.data.data.idCardFaceImg!='' && res.data.data.idCardFaceImg!=null?res.data.data.idCardFaceImg:''
                that.form.idCardEmblemImg=res.data.data.idCardEmblemImg && res.data.data.idCardEmblemImg!='' && res.data.data.idCardEmblemImg!=null?res.data.data.idCardEmblemImg:''
                that.index++
            }else{
                that.$toast(res.data.message);
            }
        }).catch((error) =>{
            that.loading=false
        });
      }
    },
    getages(id){
      let myDate = new Date(); 
      let age = myDate.getFullYear() - id.substring(6, 10); 
      return age
    },
    getages1(id){
      let myDate = new Date(); 
      let age = myDate.getFullYear() - moment(id).format('YYYY'); 
      return age
    },
    geshow(img){
      ImagePreview({
        images: [img],
        startPosition: 0,
        onClose() {
        }
      })
    },
    getshop(){
      let that=this;
      that.$axios.get(process.env.API_HOST+"api/vue/mainData/shop/getAllShopList",'').then((res) => {
        if(res.status==200){
          that.shoplist=res.data.shopList
          that.shoplist2=res.data.shopList
          if(res.data.shopList.length>0){
            let index = res.data.shopList.findIndex(item => item.value === '100')
            if(index>-1){
              that.shoplist.splice(index, 1)
            }
            if(that.shoplist.length>0 && this.type==1){
              let nindex = that.shoplist.findIndex(item => item.value === that.shopSid)
              that.shopName=that.shoplist[nindex].text
            }
          }
        }
      }).catch((error) =>{
      });
    },
    addshop(){
      let list={
          index: this.form.ledgerShopList.length,
          cancelCardTime: '',
          chestStatus: '',
          depositNo: '',
          depositStatus:'',
          guideNo:'',
          shopSid:'',
          takeCardTime:'',
          ledgerShopBrandList:[{
            brandName:'',
            brandSid:'',
            jobType:this.$route.params.jobType,
            joinTime:'',
            position:'',
            quitTime:'',
            supplySid:'',
            index:0,
          }]
        }
      this.form.ledgerShopList.push(list)
    },
    delshop(index){
      this.form.ledgerShopList.splice(index, 1)
    },
    addbrand(nindex){
      let list={
        brandName:'',
        brandSid:'',
        jobType:3,
        joinTime:'',
        position:'',
        quitTime:'',
        supplySid:'',
        index:this.form.ledgerShopList[nindex].ledgerShopBrandList.length,
      }
      this.form.ledgerShopList[nindex].ledgerShopBrandList.push(list)
    },
    delbrand(nindex,mindex){
      this.form.ledgerShopList[nindex].ledgerShopBrandList.splice(mindex, 1)
    },
    getbrand(shopSid,supplySid){
      let that=this;
      that.$axios.get(process.env.API_HOST+"api/vue/mainData/shop/getBaseMainData/"+shopSid+'?supplySid='+supplySid).then((res) => {
        if(res.status==200){
          that.brandList=res.data.data.brandList
          that.brandList1=res.data.data.brandList
          that.brandList2=res.data.data.brandList
        }
      }).catch((error) =>{
      });
    },
    gobrand(index){
      this.form.ledgerShopList[this.nindex].ledgerShopBrandList[this.mindex].brandName=this.brandList2[index].name
      this.form.ledgerShopList[this.nindex].ledgerShopBrandList[this.mindex].brandSid=this.brandList2[index].value
      this.showbrand=false
    },
    getsupply(shopSid){
      let that=this;
      that.$axios.get(process.env.API_HOST+"api/vue/mainData/shop/getBaseMainData/"+shopSid).then((res) => {
        if(res.status==200){
          that.list=res.data.data.supplyList
          that.filterList=res.data.data.supplyList
          that.filterList2=res.data.data.supplyList
        }
      }).catch((error) =>{
      });
    },
    getshowshop(nindex){
      if(this.btndis) return
      this.nindex=nindex
      this.showshop=true
    },
    goshop(index){
      if(this.index==0){
        this.shopName=this.shoplist2[index].name
        this.shopSid=this.shoplist2[index].value
        this.showshop=false
        return
      }
      this.form.ledgerShopList[this.nindex].shopName=this.shoplist2[index].name
      this.form.ledgerShopList[this.nindex].shopSid=this.shoplist2[index].value
      this.showshop=false
    },
    setshop(e){
      let value = e;
      if(!value){
        this.shoplist2 = this.shoplist;
        return;
      }
      let shoplist = [];
      let shoplist2 = [];
      // 过滤出符合条件的值
      this.shoplist.forEach((item,index)=>{
        if(item.name.includes(value)){
          let m={
            value:item.value,
            name:this.join(item.name,value)
          }
          let nlist={
            value:item.value,
            name:item.name
          }
          shoplist.push(m);
          shoplist2.push(nlist)
        }
      });
      this.shoplist = shoplist;
      this.shoplist2 = shoplist2;
    },
    getshowsupply(nindex,mindex){
      if(this.btndis) return
      console.log(this.form.ledgerShopList)
      this.nindex=nindex
      this.mindex=mindex
      this.getsupply(this.form.ledgerShopList[nindex].shopSid,this.form.ledgerShopList[nindex].ledgerShopBrandList[mindex].supplySid)
      this.showsupply=true
    },
    gosupply(index){
      this.form.ledgerShopList[this.nindex].ledgerShopBrandList[this.mindex].supply=this.filterList2[index].name
      this.form.ledgerShopList[this.nindex].ledgerShopBrandList[this.mindex].supplySid=this.filterList2[index].value
      // this.getbrand()
      this.showsupply=false
    },
    set(e){
      let value = e;
      if(!value){
        this.filterList = this.list;
        return;
      }

      let filterArr = [];
      let filterArr2 = [];
      // 过滤出符合条件的值
      this.list.forEach((item,index)=>{
        if(item.name.includes(value)){
          let m={
            value:item.value,
            name:this.join(item.name,value)
          }
          let nlist={
            value:item.value,
            name:item.name
          }
          filterArr2.push(nlist)
          filterArr.push(m);
        }
      });
      this.filterList = filterArr;
      this.filterList2 = filterArr2;
    },
    getshowbrand(nindex,mindex){
      if(this.btndis) return
      this.nindex=nindex
      this.mindex=mindex
      this.getbrand(this.form.ledgerShopList[nindex].shopSid,this.form.ledgerShopList[nindex].ledgerShopBrandList[mindex].supplySid)
      this.showbrand=true
   },
    setbrand(e){
      let value = e;
      if(!value){
        this.brandList1 = this.brandList;
        return;
      }
      let brandList1 = [];
      let brandList2 = [];
      // 过滤出符合条件的值
      this.brandList.forEach((item,index)=>{
        if(item.name.includes(value)){
          let m={
            value:item.value,
            name:this.join(item.name,value)
          }
          let nlist={
            value:item.value,
            name:item.name
          }
          brandList1.push(m);
          brandList2.push(nlist)
        }
      });
      this.brandList1 = brandList1;
      this.brandList2 = brandList2;
    },
			// 拼接
    join(str,key){
      var reg = new RegExp((`(${key})`), "gm");
      var replace = '<span style="color:#0096FF;font-weight:bold;">$1</span>';
      return str.replace(reg, replace);
    },
    getshowgent(){
      if(this.btndis) return
      this.showgent=true
    },
    onConfirmgent(value){
      this.form.memberRelation=value
      this.showgent=false
    },
    getidcard(id){
      var re = /^\d{6}(((19|20)\d{2}(0[1-9]|1[0-2])(0[1-9]|[1-2][0-9]|3[0-1])\d{3}([0-9]|x|X))|(\d{2}(0[1-9]|1[0-2])(0[1-9]|[1-2][0-9]|3[0-1])\d{3}))$/;
      if(re.test(id)){
        let birth=id.substring(6, 10) + "-" + id.substring(10, 12) + "-" + id.substring(12, 14);
        var myDate = new Date();
        var age = myDate.getFullYear() - id.substring(6, 10) - 1;
        var sec=id.substring(16,17)
        var sex=sec%2==0?'2':'1'
        this.form.sex=sex
        this.form.age=age
        this.form.birthday=birth
      }
    },
    delimg(index){
      if(index==1){
        this.form.idPhotoImg=''
      }else if(index==2){
        this.form.idCardFaceImg=''
      }else if(index==3){
        this.form.idCardEmblemImg=''
      }
    },
    beforeRead(file){
      if (file.type !== 'image/jpeg' && file.type !== 'image/jpg' && file.type !== 'image/png') {
        this.$toast('图片格式不正确');
        return false;
      }
      return new Promise((resolve) => {
          imageConversion.compressAccurately(file, 100).then(res => {
              resolve(res);
          });
      })
    },
    afterRead(file,index){
      let that=this
      that.showloading=true
      let form = new FormData()
      form.append('annexUrl', file.file)
      form.append('operator', that.idCardNo)
      that.$axios.post(process.env.API_HOST+"sysmanager/vue/guide/image",form).then((res) => {
        if(res.data.state==200){
          if(index==1){
            that.form.idPhotoImg=res.data.data.accessPath
          }else if(index==2){
            that.form.idCardFaceImg=res.data.data.accessPath
          }else if(index==3){
            that.form.idCardEmblemImg=res.data.data.accessPath
          }
        }else{
          that.$toast(res.data.desc);
          if(index==1){
            that.form.idPhotoImg=''
          }else if(index==2){
            that.form.idCardFaceImg=''
          }else if(index==3){
            that.form.idCardEmblemImg=''
          }
        }
        this.$forceUpdate()
        that.showloading=false
      }).catch((error) =>{
        that.showloading=false
      });

    },
    onConfirm2(value,index){
      this.form.educationCodeName=value
      this.form.educationCode=index+1
      this.showPicker2=false
    },
    getshowPicker2(){
      if(this.btndis) return
      this.showPicker2=true
    },
    getshowPicker(){
      if(this.btndis) return
      let myDate = new Date();
      let year = myDate.getFullYear();
      let Month = myDate.getMonth()
      let day=myDate.getDate()
      this.currentDate=new Date(year,Month,day)
      this.showPicker1=true
    },
    onConfirmtwo(time) {
        this.form.birthday=this.getDate(time);
        this.showPicker1 = false;
    },
    getshowPicker47(){
      if(this.btndis) return
      let myDate = new Date();
      let year = myDate.getFullYear();
      let Month = myDate.getMonth()
      let day=myDate.getDate()
      this.currentDate47=new Date(year,Month,day)
      this.showPicker47=true
    },
    onConfirmtwo47(time){
      this.form.issueDate=this.getDate(time);
      this.showPicker47 = false;
    },
    getshowPicker48(){
      if(this.btndis) return
      let myDate = new Date();
      let year = myDate.getFullYear();
      let Month = myDate.getMonth()
      let day=myDate.getDate()
      this.currentDate48=new Date(year,Month,day)
      this.showPicker48=true
    },
    onConfirmtwo48(time){
      this.form.expireDate=this.getDate(time);
      this.showPicker48 = false;
    },
    getDate(date){
        var time = new Date(date);
        var year= time.getFullYear()  //年
        var month = ("0" + (time.getMonth() + 1)).slice(-2); //月
        var day = ("0" + time.getDate()).slice(-2); //日
        var mydate = year + "-" + month + "-" + day;
        return mydate
    },
  }
}
</script>
<style scoped>
.page{
  box-sizing: border-box;
  padding: 0 0.4rem 0;
  /* padding: 0 0.4rem 90px; */
}
canvas{
  width: 50vh !important;
}
.formfoot{
  padding-bottom:100px;
}
.page .title{
    font-size: 20px;
		color: #0096FF;
		font-weight: 600;
    margin: 1rem 0.5rem;
    text-align: center;
}
.tit{
  font-size: 14px;
  color: #0096FF;
  font-weight: 600;
  margin: 0.4rem 0 0.3rem;
}
.tmt{
  font-size: 16px;
  margin: 0.4rem 0;
  border-left: 3px solid #0096FF;
  box-sizing: border-box;
  padding-left: 0.3rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.tmt img{
  width: 0.7rem;
  height: 0.7rem;
  box-sizing: border-box;
  padding: 0.1rem;
}
.txt{
  font-size: 14px;
  margin: 0.4rem 0 0.3rem;
}
.tmt i,.txt i{
  color: red;
  font-size: 18px;
  font-style: normal;
  margin-right: 5px;
  position: relative;
  top: 3px;
}
.fixdbottom{
  width: 100%;
  box-sizing: border-box;
  padding: 0 0.5rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: fixed;
  bottom: 20px;
  left: 0;
}
.btn{
   width: 100%;
    box-sizing: border-box;
    padding: 0 0.5rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.btn .van-button{
  width: 45%;
}
.fixdbottom .van-button{
  width: 48%;
}
.fixdbottom2 .van-button{
  width: 100%;
}
.promise{
  padding: 0;
}
.promise .protit{
  font-size: 20px;
  font-weight: bold;
  text-align: center;
  box-sizing: border-box;
  padding: 0.9rem 0.4rem 0.7rem;
}
.promise .probox{
  padding: 0 0.4rem;
}
.promise p{
  font-size: 18px;
  margin: 0 0 5px;
  line-height: 160%;
}
.promise img{
  width: 135px;
  display: block;
  margin: 10px 0 20px 2em;
}
.prodate{
  text-align: right;
  box-sizing: border-box;
  padding-bottom: 0.7rem;
}
.indent{
  text-indent: 2em;
}
.widbox{
  position: relative;
}
.widbox i{
  position: absolute;
  top: 0;
  right: 0;
  font-style: normal;
  font-size: 14px;
  border-radius: 0 0 0 12px;
  background: rgba(0, 0, 0, .7);
  text-align: center;
  box-sizing: border-box;
  width: 22px;
  height: 22px;
  line-height: 22px;
  color: #fff;
}
.flexcenter{
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}
.boximg{
  box-sizing: border-box;
  padding: 90px 25px;
}
.boximg img{
  width: 90px;
  height: 90px;
  margin-bottom: 20px;
}
.boximg .btit{
  font-size: 24px;
  font-weight: bold;
}
.boximg p{
  line-height: 160%;
  font-size: 18px;
  text-align: center;
}
.boximg .text{
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}
.van-button--primary{
  background-color: #0096FF;
  border-color: #0096FF;
}
.van-cell-group--inset{
  margin: 0;
  border:1px solid #ebedf0;
  border-radius: 0.1rem;
}
.van-cell-group--inset .van-cell{
  border: none;
}
.van-cell{
  border:1px solid #ebedf0;
  border-radius: 0.1rem;
}
.foot .van-button{
  margin: 20px 0;
}
.foot .van-checkbox{
  margin: 30px 0;
}
.tipss{
  color: rgba(69,90,100,.6);
  font-size: 14px;
}
>>>.van-search{
  position: fixed;
  top: 40%;
  left: 0;
  width: 100%;
  z-index: 999;
}
>>> .van-search__content{
  padding-left: 0;
}
>>> .van-list{
  position: absolute;
  top: 1.5rem;
  left: 0;
  width: 100%;
}
>>> .van-search .van-cell{
  padding-left: 12px;
}
>>> .van-cell::after,>>> .van-hairline--top-bottom::after, >>> .van-hairline-unset--top-bottom::after,.noborder{
  border: none;
}
>>> .van-checkbox__label{
  font-size: 18px;
}
>>> .van-checkbox__icon .van-icon{
  border-radius: 4px;
}
.esignTest{
  width: 100%;
  height: 100%;
}
>>> .van-field__control{
  display: block;
  width: 100%;
}
>>> .van-radio-group{
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
>>> .van-radio+.van-radio{
  margin-left:10px;
}
>>> .van-uploader{
  width: 100%;
}
>>> .van-uploader__wrapper{
  width: 100%;
  height: 0;
  padding-top: 60.2%;
  box-sizing: border-box;
  margin: 0;
}
>>> .van-uploader__upload{
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  margin: 0;
}
>>> .van-button--disabled{
  opacity: .3;
}
/* .zm >>>.van-uploader__upload{
  background: url('http://116.196.116.98:4869/52193ed8a175ad5dcd07fbf227cdee59?f=png') no-repeat center;
  background-size:contain;
}
.fm >>>.van-uploader__upload{
  background: url('http://116.196.116.98:4869/35b620480fcefb70d8674d447bb54691?f=png') no-repeat center;
  background-size:contain;
} */
/* .zm >>>.van-uploader__upload-icon,.zm >>>.van-uploader__upload-text,.fm >>>.van-uploader__upload-icon,.fm >>>.van-uploader__upload-text{
  display: none;
} */
>>> .van-radio__label--disabled{
  color: #323233;
}
>>> .van-radio__icon--disabled .van-icon{
  background-color: #fff;
}
>>> .van-radio__icon--checked .van-icon{
      color: #fff;
    background-color: #1989fa;
    border-color: #1989fa;
}
>>> .van-checkbox__icon--disabled.van-checkbox__icon--checked .van-icon{
    color: #fff;
    background-color: #1989fa;
    border-color: #1989fa;
}
>>> .van-checkbox__label--disabled{
  color: #323233;
}
>>> .van-picker-column__item--selected{
  background: #ddd;
}
.showbj{
  position: fixed;
  width: 100%;
  height: 100vh;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, .6);
  z-index: 5;
  display: flex;
  align-items: center;
  justify-content: center;
}
.noheight >>> .van-uploader__wrapper{
  padding-top: 0 !important;
}
.noheight >>> .van-field__body{
  height: 38px;
}
.notop{
  padding-top: 0;
}
.row-between{
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
}
.name{
  color: #0096FF;
  margin-right: 20px;
}
</style>


// WEBPACK FOOTER //
// src/view/addledger.vue